import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing Supabase environment variables');
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
    flowType: 'implicit'
  },
  global: {
    headers: {
      'X-Client-Info': 'mana-mamidipallu'
    }
  }
});

// Initialize auth state
supabase.auth.onAuthStateChange((event, session) => {
  if (event === 'SIGNED_OUT' || event === 'USER_DELETED') {
    localStorage.removeItem('supabase.auth.token');
  }
});

// Add error handling for auth state
supabase.auth.onAuthStateChange((event, session) => {
  if (event === 'TOKEN_REFRESHED') {
    console.log('Auth token refreshed successfully');
  }
  if (event === 'SIGNED_IN') {
    console.log('Signed in successfully');
  }
});

// Add network error retry logic
let retryCount = 0;
const maxRetries = 3;

export const retryAuth = async (operation: () => Promise<any>) => {
  try {
    return await operation();
  } catch (error) {
    if (retryCount < maxRetries) {
      retryCount++;
      await new Promise(resolve => setTimeout(resolve, 1000 * retryCount));
      return retryAuth(operation);
    }
    throw error;
  }
};

// Reset retry count on sign out
supabase.auth.onAuthStateChange((event) => {
  if (event === 'SIGNED_OUT') {
    retryCount = 0;
  }
});